function statusLabel(status) {
  const normalized = String(status || "NOT_CALCULATED").toUpperCase();

  if (normalized === "READY") return "Jalur siap";
  if (normalized === "STALE") return "Jalur perlu diperbarui";
  if (normalized === "CALCULATING") return "Menghitung jalur";
  if (normalized === "BLOCKED") return "Jalur belum dapat dihitung";
  if (normalized === "ERROR") return "Jalur tidak dapat dihitung";
  return "Jalur belum dihitung";
}

function statusMessage({ route, readiness }) {
  const status = String(route?.status || "NOT_CALCULATED").toUpperCase();

  if (status === "STALE") {
    return "Urutan stop atau koordinat berubah setelah jalur terakhir dihitung.";
  }

  if (status === "ERROR") {
    return route?.errorMessage || "Layanan routing tidak merespons atau tidak menemukan jalur.";
  }

  if (status === "BLOCKED" || readiness?.canCalculate === false) {
    return readiness?.message || "Lengkapi koordinat sebelum menghitung jalur.";
  }

  if (status === "NOT_CALCULATED") {
    return "Jalur akan dihitung ketika koordinat sudah lengkap.";
  }

  return "";
}

export function MapStatusOverlay({
  calculating = false,
  error = "",
  onRecalculate,
  onRetry,
  readiness,
  route,
}) {
  const status = String(route?.status || "NOT_CALCULATED").toUpperCase();
  const showPanel =
    calculating ||
    error ||
    status === "STALE" ||
    status === "ERROR" ||
    status === "BLOCKED" ||
    readiness?.canCalculate === false ||
    status === "NOT_CALCULATED";

  if (!showPanel) return null;

  const message = error || statusMessage({ route, readiness });
  const canCalculate = readiness?.canCalculate !== false;

  return (
    <aside
      aria-live="polite"
      className={`map-status-overlay map-status-overlay--${status.toLowerCase()}`}
    >
      <strong>
        {calculating ? "Menghitung jalur…" : error ? "Jalur tidak dapat dihitung" : statusLabel(status)}
      </strong>

      {message && <p>{message}</p>}

      {readiness?.affectedStops?.length > 0 && (
        <ul>
          {readiness.affectedStops.slice(0, 5).map((stop) => (
            <li key={stop.key || `${stop.displaySequence}-${stop.customerName}`}>
              Stop {stop.displaySequence}: {stop.customerName}
            </li>
          ))}
        </ul>
      )}

      <div className="map-status-overlay__actions">
        {status === "STALE" && canCalculate && (
          <button
            className="primary-button"
            disabled={calculating}
            onClick={() => onRecalculate?.({ force: true })}
            type="button"
          >
            Hitung Ulang Jalur
          </button>
        )}

        {(status === "ERROR" || error) && canCalculate && (
          <button
            className="secondary-button"
            disabled={calculating}
            onClick={() => onRetry?.({ force: true })}
            type="button"
          >
            Coba Lagi
          </button>
        )}

        {status === "NOT_CALCULATED" && canCalculate && (
          <button
            className="primary-button"
            disabled={calculating}
            onClick={() => onRecalculate?.({ force: false })}
            type="button"
          >
            Hitung Jalur
          </button>
        )}
      </div>
    </aside>
  );
}
